import { createAuthClient } from 'better-auth/react';
import { twoFactorClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  basePath: '/api/auth',
  plugins: [
    twoFactorClient({
      onTwoFactorRedirect() {
        // Keep the return path (e.g. the native app handoff) through the two-factor step.
        const next = new URLSearchParams(window.location.search).get('next');
        window.location.assign(`/login?step=2fa${next ? `&next=${encodeURIComponent(next)}` : ''}`);
      },
    }),
  ],
});
